import { FileSizePipe } from '@agent/agent-interface/contact-view/chat/pipes/file-size.pipe';

const MODULE_NAME = 'fileSize';

/**
 * @deprecated use FileSizePipe for NGX applications in the future
 * still used in contact-view-histo-popin
 */
export class FileSizeFilter {
  public static factory() {
    const pipe = new FileSizePipe();
    const factoryFunction = () => bytes => {
      return pipe.transform(bytes);
    };
    factoryFunction.$inject = [];

    return factoryFunction;
  }
}

export default MODULE_NAME;
